import Image from "next/image";
import Link from "next/link";
import { useState, useEffect } from "react";

import { useAppContext } from "@/context/Context";
import { useRouter } from "next/router";
import emoji from "../../../public/images/icons/hand-emojji.svg";

const HeaderTopEight = ({
  bgColor,
  gapSpaceBetween,
  container,
  flexDirection,
}) => {
  const router = useRouter();
  const { toggle, setToggle } = useAppContext();
  const [showMobilePopup, setShowMobilePopup] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      if (window.innerWidth <= 767) {
        setShowMobilePopup(true);
      } else {
        setShowMobilePopup(false);
      }
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const closeMobilePopup = () => {
    setShowMobilePopup(false);
  };

  return (
    <>
      {showMobilePopup && (
        <div className="mobilePopup">
          <button className="popupClose" onClick={closeMobilePopup}>
            ×
          </button>
          
          <div className="popupBadge">
            🔥 Super Hot Offer
          </div>
          
          <div className="popupText">
            <Image 
              src={emoji} 
              alt="Hand Emojji" 
              className="popupEmoji"
            />
            Intro price! First 100 Registration (Instructors) for free.
          </div>
          
          <Link
            className="popupButton"
            href="/login?role=instructor"
            onClick={closeMobilePopup}
          >
            Register Now →
          </Link>
        </div>
      )}

      <div
        className={`rbt-header-top rbt-header-top-1 ${gapSpaceBetween} ${bgColor} top-expended-activation d-none d-lg-block ${
          !toggle ? "d-none" : ""
        }`}
        style={{ minHeight: '40px', paddingTop: '10px', paddingBottom: '8px', fontSize: '13px' }}
      >
        <div className={`${container}`}>
          <div className="top-expended-wrapper">
            <div
              className={`top-expended-inner rbt-header-sec align-items-center justify-content-center ${flexDirection}`}
            >
              <div className="rbt-header-content d-flex align-items-center justify-content-center">
                <div className="header-info d-flex align-items-center">
                  <span className="rbt-badge variation-02 bg-color-primary color-white radius-round me-3">
                    🔥 Super Hot Offer
                  </span>
                  <span className="news-text d-flex align-items-center me-3">
                    <Image
                      src={emoji}
                      width={22}
                      height={22}
                      alt="Hand Emojji Images"
                      className="me-2"
                    />
                    Intro price! First 100 Registration (Instructors) for free.
                  </span>
                  <Link
                    className="text-decoration-none rbt-badge variation-02 bg-color-primary color-white radius-round me-3"
                    href="/login?role=instructor"
                    style={{ fontSize: 'inherit', color: 'inherit' }}
                  >
                    Register Now →
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderTopEight;